import { LocalDate } from "@js-joda/core";
import { atom, useAtom } from "jotai";
import { Messages } from "../../core/api";
import { AgencyMemberId, ContractTypeId, OfficeId } from "../../shared/schema/schema";

// Filters shared between the Dashboard and Patients tabs so they persist when
// switching tabs. List-only filters (state, search) stay local to the list tab.
export type SharedUtilizationFilters = {
  from?: string;
  to?: string;
  officeIds?: OfficeId[];
  contractTypeIds?: ContractTypeId[];
  coordinatorIds?: AgencyMemberId[];
  periodTypes?: string[];
  patientStatuses?: Messages["PatientStatus"][];
};

function today(): { from: string; to: string } {
  const now = LocalDate.now().toString();
  return { from: now, to: now };
}

// Module-level atom: state survives tab (un)mounts until a full page reload.
const sharedUtilizationFiltersAtom = atom<SharedUtilizationFilters>({ ...today() });

export function useSharedUtilizationFilters() {
  return useAtom(sharedUtilizationFiltersAtom);
}
